<main class="content">
  <a routerLink="zona-de-aprendizaje" type="button" class="back-button">< Regresar a zona de aprendizaje</a>
  <section class="form-configuration">
    <div class="top-info">
      <article class="top-left-info">
        <img [src]="imgUser" (error)="setDefaultImage($event)" class="img-user" alt="imágen usuario">
        <span class="name">{{userProfile?.attributes.field_name}}</span>
      </article>
    </div>
    <article class="top-nav">
      <a class="item-menu" [routerLink]="['/configuración']" fragment="datos" [class.active]="currentFragment === 'datos'">Mis datos</a>
      <a class="item-menu" [routerLink]="['/configuración']" fragment="seguridad" [class.active]="currentFragment === 'seguridad'">Seguridad</a>
      <a class="item-menu" [routerLink]="['/configuración']" fragment="perfil" [class.active]="currentFragment === 'perfil'">Perfil</a>
    </article>
    <!-- Formulario Data -->
    <!-- <article class="top-info"  *ngIf="(currentFragment === 'datos')">
      <span class="text-required"><span>¡Importante!: </span>Si actualizas tu número de documento serás redirigido al inicio de sesión.</span>
    </article> -->
    <form class="row" [formGroup]="configurationForm" *ngIf="configurationForm && (currentFragment === 'datos')">
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12  form-item">
        <label for="names" class="text-item">Nombres *</label>
        <input type="text" id="names" placeholder="Ingresa tus nombres" class="form-control" formControlName="field_name"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_name'].errors || confiForm['field_name'].touched && confiForm['field_name'].errors}" required>
        <span *ngIf="submitted && confiForm['field_name'].errors && confiForm['field_name'].errors['required'] ||
        confiForm['field_name'].touched && confiForm['field_name'].errors && confiForm['field_name'].errors['required']"  class="error-form">
          Escribe al menos un Nombre
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="lastNames" class="text-item">Apellidos *</label>
        <input type="text" id="lastNames" placeholder="Ingresa tus apellidos" class="form-control" formControlName="field_lastname"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_lastname'].errors || confiForm['field_lastname'].touched && confiForm['field_lastname'].errors}" required>
        <span *ngIf="submitted && confiForm['field_lastname'].errors && confiForm['field_lastname'].errors['required'] ||
        confiForm['field_lastname'].touched && confiForm['field_lastname'].errors && confiForm['field_lastname'].errors['required']"  class="error-form">
          Escribe al menos un apellido
        </span>
      </article>
      <!-- <article class="col-12 form-item">
        <label class="text-item">Nombre de usuario</label>
        <input type="text" placeholder="Escriba un nombre de usuario" class="form-control" formControlName="name"
        [ngClass]="{ 'is-invalid': submitted && confiForm['name'].errors || confiForm['name'].touched && confiForm['name'].errors}" required>
        <span *ngIf="submitted && confiForm['name'].errors && confiForm['name'].errors['required'] ||
        confiForm['name'].touched && confiForm['name'].errors && confiForm['name'].errors['required']"  class="error-form">
          El nombre de usuario es requerido
        </span>
        <span *ngIf="confiForm['name'].errors && confiForm['name'].errors['minlength']" class="error-form">
          El nombre de usuario debe tener mínimo 8 caracteres
        </span>
        <span *ngIf="submitted && userExists" class="error-form">
          El nombre de usuario ya está en uso, por favor elija otro.
        </span>
      </article> -->
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="document" class="text-item">Tipo de documento *</label>
        <select id="document" class="form-control form-select gender" formControlName="field_document_type"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_document_type'].errors || confiForm['field_document_type'].touched && confiForm['field_document_type'].errors}" required>
          <option *ngFor="let type of formTypes?.documentTypes" [value]="type.id">{{type.attributes?.name}}</option>
        </select>
        <span *ngIf="submitted && confiForm['field_document_type'].errors && confiForm['field_document_type'].errors['required'] ||
        confiForm['field_document_type'].touched && confiForm['field_document_type'].errors && confiForm['field_document_type'].errors['required']"  class="error-form">
          Elija el tipo de documento
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="documentNumber" class="text-item">Número de documento *</label>
        <input type="text" id="documentNumber" placeholder="Digita tu número de documento" class="form-control disabled-link" formControlName="field_document"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_document'].errors || confiForm['field_document'].touched && confiForm['field_document'].errors}" readonly>
        <span *ngIf="submitted && confiForm['field_document'].errors && confiForm['field_document'].errors['required'] ||
        confiForm['field_document'].touched && confiForm['field_document'].errors && confiForm['field_document'].errors['required']"  class="error-form">
          El documento es obligatorio
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="birthdate" class="text-item">Fecha de nacimiento</label>
        <input type="date" id="birthdate" class="form-control" formControlName="field_birthdate"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_birthdate'].errors || confiForm['field_birthdate'].touched && confiForm['field_birthdate'].errors}" required>
        <span *ngIf="submitted && confiForm['field_birthdate'].errors && confiForm['field_birthdate'].errors['required'] ||
        confiForm['field_birthdate'].touched && confiForm['field_birthdate'].errors && confiForm['field_birthdate'].errors['required']"  class="error-form">
          La fecha de nacimiento es obligatoria
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="gender" class="text-item">Género</label>
        <select id="gender" class="form-control form-select gender" formControlName="field_gender"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_gender'].errors || confiForm['field_gender'].touched && confiForm['field_gender'].errors}" required>
          <option *ngFor="let gender of formTypes?.genders" [value]="gender.id">{{gender.attributes?.name}}</option>
        </select>
        <span *ngIf="submitted && confiForm['field_gender'].errors && confiForm['field_gender'].errors['required'] ||
        confiForm['field_gender'].touched && confiForm['field_gender'].errors && confiForm['field_gender'].errors['required']"  class="error-form">
          Seleccione su género
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="country" class="text-item">País de residencia</label>
        <input type="text" id="country" placeholder="Ingresa tu país de residencia" class="form-control" formControlName="field_country" autocomplete="country">
      </article>
      <article class="dropdown col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="city" class="text-item">Ciudad de residencia</label>
        <input type="text" id="city" placeholder="Ingresa tu ciudad de residencia" class="form-control" formControlName="field_city">
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="profession" class="text-item">Profesión / rol *</label>
        <input type="text" id="profession" placeholder="Profesión" class="form-control" formControlName="field_profession"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_profession'].errors || confiForm['field_profession'].touched && confiForm['field_profession'].errors}" required>
        <span *ngIf="submitted && confiForm['field_profession'].errors && confiForm['field_profession'].errors['required'] ||
        confiForm['field_profession'].touched && confiForm['field_profession'].errors && confiForm['field_profession'].errors['required']"  class="error-form">
          La profesión es requerida
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="enterprise" class="text-item">Entidad/Empresa *</label>
        <select id="enterprise" class="form-control form-select gender" formControlName="field_company"
        [ngClass]="{ 'is-invalid': submitted && confiForm['field_company'].errors || confiForm['field_company'].touched && confiForm['field_company'].errors}" required>
          <option *ngFor="let company of formTypes?.companies" [value]="company.id">{{company.attributes?.name}}</option>
        </select>
        <span *ngIf="submitted && confiForm['field_company'].errors && confiForm['field_company'].errors['required'] ||
        confiForm['field_company'].touched && confiForm['field_company'].errors && confiForm['field_company'].errors['required']"  class="error-form">
          Selecciona la empresa a la que perteneces
        </span>
      </article>
      <article class="col-12 form-item">
        <label for="userImage" class="text-item">Cargar foto de perfil</label>
          <div type="file" class="form-control load-image">
            <img src="../../../assets/icons/upload.svg" alt="Logo cargar imágen">
            <span *ngIf="filename">{{filename}}</span>
            <span>Foto de perfil: Click para subir o soltar el archivo PNG o JPG (max, 800x400px)</span>
          </div>
          <input type="file" id="userImage" accept=".jpg, .jpeg, .png" class="form-control load-file" (change)="onFileSelected($event)" formControlName="user_picture">
      </article>
    </form>
    <!-- Formulario seguridad -->
    <article class="top-info" *ngIf="(currentFragment === 'seguridad')">
      <span class="text-required"><span>¡Importante!: </span>Si deseas actualizar tu correo electrónico o contraseña por seguridad debes proporciona tu contraseña actual. Al actualizar tu contraseña serás redirigido al inicio de sesión.</span>
    </article>
    <form class="row form-pass" [formGroup]="configurationForm" *ngIf="configurationForm && (currentFragment === 'seguridad')">
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item pass-field">
        <label for="password" class="text-item">Contraseña Actual</label>
        <input [type]="hideCurrent ? 'password' : 'text'" id="password" placeholder="Escribe una contraseña" class="form-control" formControlName="current_pass"
        [ngClass]="{ 'outline-error': submitted && confiForm['current_pass'].errors || confiForm['current_pass'].touched && confiForm['current_pass'].errors}" [required]="currentPassRequired || mailChanged">
        <i (click)="toggleHideCurrent()" class="bi" [ngClass]="hideCurrent ? 'bi-eye-slash' : 'bi-eye'"></i>
        <span *ngIf="submitted && confiForm['current_pass'].errors && confiForm['current_pass'].errors['required'] && !forgotPass ||
        confiForm['current_pass'].touched && confiForm['current_pass'].errors && confiForm['current_pass'].errors['required'] && !forgotPass || confiForm['current_pass'].errors && confiForm['current_pass'].errors['required'] && !forgotPass" class="error-form">
          Escriba su contraseña actual
        </span>
        <span *ngIf="submitted && forgotPass" class="error-form">
          La contraseña no se envió o es incorrecta
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item">
        <label for="email" class="text-item">Correo electrónico *</label>
        <input type="email" id="email" placeholder="usuario@example.com" class="form-control" formControlName="mail"
        [ngClass]="{ 'is-invalid': submitted && confiForm['mail'].errors || confiForm['mail'].touched && confiForm['mail'].errors}" autocomplete="email" required>
        <span *ngIf="submitted && confiForm['mail'].errors && confiForm['mail'].errors['required'] ||
        confiForm['mail'].touched && confiForm['mail'].errors && confiForm['mail'].errors['required']"  class="error-form">
          El email es requerido
        </span>
        <span *ngIf="(submitted || confiForm['mail'].touched) &&
             confiForm['mail'].errors &&
             confiForm['mail'].errors['invalidEmailFormat'] &&
             confiForm['mail'].value"
              class="error-form">
          El formato del email no es válido.
        </span>
        <span *ngIf="submitted && mailExists" class="error-form">
          El correo electrónico ya está en uso, por favor elija otro.
        </span>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item pass-field">
        <label for="newPass" class="text-item">Nueva contraseña</label>
        <input [type]="hide ? 'password' : 'text'" id="newPass" placeholder="Escribe una contraseña" class="form-control" formControlName="pass"
        [ngClass]="{ 'outline-error': submitted && confiForm['pass'].errors || confiForm['pass'].touched && confiForm['pass'].errors}">
        <i (click)="toggleHide()" class="bi" [ngClass]="hide ? 'bi-eye-slash' : 'bi-eye'"></i>
        <div *ngIf="confiForm['pass'].errors && confiForm['pass'].errors['minlength']" class="error-form">
          La contraseña debe tener mínimo 8 caracteres
        </div>
      </article>
      <article class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 form-item pass-field">
        <label for="confirmPassword" class="text-item">Confirmar contraseña *</label>
        <input [type]="hideConfirm ? 'password' : 'text'" id="confirmPassword" placeholder="Vuelva a escribir su contraseña" class="form-control" formControlName="confirmPassword"
        [ngClass]="{ 'outline-error': submitted && confiForm['confirmPassword'].errors || confiForm['confirmPassword'].touched && confiForm['confirmPassword'].errors}" [required]="confiForm['pass'].dirty">
        <i (click)="toggleHideConfirm()" class="bi" [ngClass]="hideConfirm ? 'bi-eye-slash' : 'bi-eye'"></i>
        <span *ngIf="submitted && confiForm['confirmPassword'].errors && confiForm['confirmPassword'].errors['required'] ||
        confiForm['confirmPassword'].touched && confiForm['confirmPassword'].errors && confiForm['confirmPassword'].errors['required']"  class="error-form">
          Confirme su contraseña
        </span>
      </article>
      <article *ngIf="configurationForm.value.confirmPassword && !passwordsMatch()" class="error">
        Las contraseñas no coinciden
      </article>
    </form>
    <!-- Formulario Perfil -->
    <form class="row" [formGroup]="configurationForm" *ngIf="configurationForm && (currentFragment === 'perfil')">
      <article class="col form-item pass-field">
        <label for="descripcion" class="text-item">Descripción o Perfil</label>
        <textarea id="descripcion" rows="5" formControlName="field_profile" class="form-control"></textarea>
      </article>
    </form>
    <article class="top-right-info">
      <a type="button" class="back-button right-buttons" (click)="restoreFields()">Restablecer</a>
      <button class="back-button save-button right-buttons" (click)="onSubmit()" [class.opacity]="!configurationForm.dirty"  [disabled]="!configurationForm.dirty">Guardar</button>
    </article>
  </section>
</main>
